// Copyright © 2025 Niphtio, Inc.
// All Rights Reserved.

import isObject from 'lodash/isObject';
import { UTMData } from './UTMdata';

export const getIsSomeUTM = (utm: UTMData) => {
  return isObject(utm) && Object.values(utm).some((value) => value != null);
};
